import {Component, OnInit} from "@angular/core";
import {ProjectService} from "../../services/project.service";
import {Project} from "../../services/model/projects.model";
import {MatDialog, MatDialogRef} from '@angular/material';
import {FilterComponent} from '../../dialogs/filter/filter.component';
import {environment} from '../../../environments/environment';
import {Filter} from '../../services/model/filter.model';
import {isNullOrUndefined} from "util";
import {GlobalService} from '../../services/global.service';

@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
})
export class ListComponent implements OnInit{

    projects: any;
    add_project: boolean;
    new_project: Project;
    sortBy: any;
    env = environment;
    loading: boolean;
    filterRef: MatDialogRef<FilterComponent>;
    filter: Filter;
    is_filter: boolean;
    constructor(
        public dialog: MatDialog,
        private projectServ: ProjectService,
        public globalServ: GlobalService
    ){
        this.add_project = false;
        /**
         * Default sorting when the component gets loaded first
         * @type {{}}
         */
        this.sortBy = {};
        this.sortBy['child'] = 'created_at';
        this.sortBy['order'] = 'desc';

        this.loading = false;
        this.filter = new Filter();
        this.is_filter = false;
    }

    ngOnInit() {
         this.getProjects();
    }

    getProjects(){
        this.loading = true;
        this.projects = this.projectServ.getProjectsByCat(this.sortBy.child, this.sortBy.order, {}).map(actions => {
            console.log('action before filters', actions);
            const no_filters = Object.keys(this.filter).length === 0;
            actions = this.filterProject(actions, no_filters);
            console.log('action after filters', actions);
            this.loading = false;
            return actions;
        })
    }

    orderBy(child){
        const status = this.sortBy.order == 'desc' ? 'asc' : 'desc';
        this.sortBy = {
            child: child,
            order: status
        };

        this.getProjects();
    }

    filterProject(data: any, noFilters: boolean){

        data = data.map(a => {
            const data = a.payload.doc.data() as Project;
            const key = a.payload.doc.id;
            return { key, ...data };
        });

        if(!noFilters){
            console.log('is filters');
            let new_data = [];
            data.forEach((item, index) => {
                if(this.isVisible(item)){
                    new_data.push(item);
                }
            });

            return new_data;
        }

        return data;

    }

    isVisible(item: Project) {

        let status = true;
        for(let key in this.filter){
            const is_number = (typeof this.filter[key] == 'number');
            const is_boolean = (typeof this.filter[key] == 'boolean');

            if(is_number){
                status = this.filter[key] == item[key];

                if(!status){
                    break;
                }
            }


        }

        // console.log(this.filter, item, status);
        return status;
    }

    toggleNew(){
        this.add_project = !this.add_project;
        if(this.add_project){
            this.new_project = new Project();
        }
    }

    openFilter(){
        let old = this.globalServ.cloneObject(this.filter);
        this.filterRef = this.dialog.open(FilterComponent, {width: this.env.dialogs.width, data: old});
        this.filterRef.componentInstance.filter_type = 'projects';

        this.filterRef.afterClosed().subscribe(result => {
            this.is_filter = true;
            if(result) {
                this.filter = result;
                this.getProjects();
            } else {
            }
        });
    }

    addNew(event){
        this.toggleNew();
        event.preventDefault();
        this.projectServ.createProject(this.new_project)
            .then(
                r => {
                    console.log('project added');
                }
            )
    }

    removeFilter(item: string){
        this.filter[item] = null;
        this.getProjects();
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/list/list.component.ts